<template>
    <div class="internal-resources-root">
        <Header :label="$t('resourcesInternal.header')" overlap="none" />

        <MainLayout marginTop>
            <ProfileModule slot="right" />
            <FeaturedResource slot="right" />
            <VerifyModule slot="right" />
            <WidgetModule slot="right" />

            <CVTemplateButton slot="center" />

            <ResourcesFolderGrid v-if="hasFiles" slot="center" :files="files" />
            <NoContent
                v-else
                slot="center"
                :caption="$t('resourcesInternal.resourceNoContent')"
            ></NoContent>
        </MainLayout>
    </div>
</template>

<script>
// Components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import VerifyModule from '~/components/miscellaneous/VerifyModule';
import NoContent from '~/components/miscellaneous/NoContent';
import FeaturedResource from '~/components/smart/FeaturedResource';
import WidgetModule from '~/components/smart/WidgetModule.vue';
import ResourcesFolderGrid from './components/ResourcesFolderGrid';
import ResourceService from '~/services/ResourceService';
import CVTemplateButton from './components/CVTemplateButton';

// Utils
import URLS from '~/URLS';
import i18n from '~/i18n';

export default {
    name: 'ResourcesInternal',
    components: {
        ResourcesFolderGrid,
        Header,
        MainLayout,
        ProfileModule,
        VerifyModule,
        FeaturedResource,
        NoContent,
        CVTemplateButton,
        WidgetModule,
    },
    data: () => ({
        search: '',
        breadcrumb: [
            {
                exact: true,
                text: i18n.t('resourcesInternal.header'),
                to: URLS.internalResources,
            },
        ],
        files: [],
    }),
    computed: {
        hasFiles() {
            return !!this.files;
        },
    },
    mounted() {
        ResourceService.getRootFolders().then(async res => {
            let files = res.data;
            for (let i = 0; i < files.length; i++) {
                const elementsData = await ResourceService.getFolderById(files[i].id);
                files[i] = { ...files[i], count: elementsData.data.length };
            }
            this.files = files;
        });
    },
};
</script>

<style scoped>
.internal-resources-root {
    padding-bottom: 100px;
}
.internal-resources-top-bar {
    padding: 20px;
}
</style>
